import { incYenOf, incOf } from '../lib/pricing';
export const coursesHero = {
  title: 'コース一覧・比較',
  titleEn: 'COURSES',
  lead: '日本執事アカデミーは、目的に応じて選べる3つのコースをご用意しています。',
};

export const courseCards = [
  {
    name: 'エッセンシャルコース',
    nameEn: 'ESSENTIAL COURSE',
    duration: '1ヶ月',
    days: '8日間',
    hours: '48時間',
    price: incYenOf('ac-essential'),
    target: '初心者・キャリアチェンジ希望者',
    description: '執事の基本所作と接遇の型を集中的に学ぶ入門コース。テーブルマナーからティーサービスまで、基礎を確実に固めます。',
    certification: '認定アソシエイトバトラー',
    href: '/courses/essential',
    imageSeq: 'course-card-essential-2026',
  },
  {
    name: 'アドバンスコース',
    nameEn: 'ADVANCED COURSE',
    duration: '2ヶ月',
    days: '12日間',
    hours: '72時間',
    price: incYenOf('ac-advanced'),
    target: '基礎知識がある方・スキルアップ希望者',
    description: 'エッセンシャルの内容を含んだ上で、ワインサービスやイベント運営など、より高度な接遇技術まで習得する中級コース。未経験からの直接受講も可能で、本物のサービスを体験する特別実習も含みます。',
    certification: '認定プロフェッショナルバトラー',
    href: '/courses/advanced',
    imageSeq: 'course-card-advanced-2026',
    recommended: true,
  },
  {
    name: 'マスターコース',
    nameEn: 'MASTER COURSE',
    duration: '3ヶ月',
    days: '16日間',
    hours: '96時間',
    price: incYenOf('ac-master'),
    target: 'プロ志望者・管理職を目指す方',
    description: 'エッセンシャル・アドバンスの内容を含んだ上で、管理・危機対応・国際プロトコルまでを網羅する最上級コース。未経験からの直接受講も可能で、修了時には卒業ディナー実技試験を実施します。',
    certification: '認定マスターバトラー',
    href: '/courses/master',
    imageSeq: 'course-card-master-2026',
  },
];

export const comparisonRows = [
  { label: '期間', essential: '1ヶ月', advanced: '2ヶ月', master: '3ヶ月' },
  { label: '総時間', essential: '48時間', advanced: '72時間', master: '96時間' },
  { label: '受講料（税込）', essential: `${incYenOf('ac-essential')}円`, advanced: `${incYenOf('ac-advanced')}円`, master: `${incYenOf('ac-master')}円` },
  { label: '開校時期', essential: '7月・1月', advanced: '5〜6月・11〜12月', master: '2〜4月・9〜11月' },
  { label: '対象者', essential: '初心者・キャリアチェンジ希望者', advanced: '基礎知識がある方・スキルアップ希望者（未経験からの直接受講も可）', master: 'プロ志望者・管理職を目指す方（未経験からの直接受講も可）' },
  { label: '到達目標', essential: '基本的な所作と接遇の型を身につけ、単独で日常的なサービスができる', advanced: 'エッセンシャルの内容を含めた高度なサービス技術とワイン知識を備え、複数ゲストへの対応ができる', master: 'エッセンシャル・アドバンスの内容を含めた管理・危機対応・国際儀礼を修め、執事長としてチームを統率できる' },
  { label: '主な学習内容', essential: '基本マナー・家事管理・テーブルセッティング・紅茶とコーヒー・衣類ケア・コミュニケーション', advanced: 'エッセンシャルの全内容＋高度サービス技術・ワインとスピリッツ・イベント計画運営・国際マナー・高級衣類ケア', master: 'エッセンシャル・アドバンスの全内容＋家政管理・危機対応とセキュリティ・国際プロトコル・VIP対応・リーダーシップ' },
  { label: '認定資格', essential: '認定アソシエイトバトラー', advanced: '認定プロフェッショナルバトラー', master: '認定マスターバトラー' },
  { label: '編入優遇', essential: '—', advanced: 'E修了→▲80,000円', master: 'A修了→▲180,000円' },
];

export const courseSelectorItems = [
  {
    icon: 'ri-seedling-line',
    title: '初めての方はエッセンシャル',
    description: '執事の基礎を一から学びたい方、サービス業へのキャリアチェンジを考えている方に最適です。基本所作から丁寧に積み上げ、確かな土台を築きます。',
    href: '/courses/essential',
  },
  {
    icon: 'ri-stairs-line',
    title: '経験者はアドバンス',
    description: 'エッセンシャルの内容を含むため、未経験の方も直接受講できます。接客・サービスのご経験をお持ちの方、エッセンシャル修了からさらに専門性を高めたい方にも。ワインやイベント運営の高度な技能を身につけます。',
    href: '/courses/advanced',
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'プロ・管理職志望はマスター',
    description: 'エッセンシャル・アドバンスの内容を含むため、未経験の方も直接受講できます。執事としての独立・就業や、ホテル・レジデンスの管理職を目指す方に。家政管理や危機対応まで、プロフェッショナルとしての全領域を修めます。',
    href: '/courses/master',
  },
];

export const coursesFaqs = [
  {
    question: '初心者はどのコースですか？',
    answer:
      '初めての方にはエッセンシャルコース（1ヶ月・48時間）をお勧めします。基礎の所作から体系的に学べます。',
  },
  {
    question: '途中のコースから始められますか？',
    answer:
      'はい。アドバンスはエッセンシャルの内容を、マスターはエッセンシャル・アドバンスの内容を含むため、未経験からでも直接始められます。最適な選択は個別相談でもご提案します。',
  },
  {
    question: '支払い方法は？',
    answer:
      '銀行振込による一括払いのみです。分割払い・クレジットカードはご利用いただけません。',
  },
];

export const coursesRelatedPages = [
  {
    title: 'エッセンシャルコース',
    description: '基礎から始める入門課程',
    href: '/courses/essential',
  },
  {
    title: 'アドバンスコース',
    description: '専門技能を磨く中級課程',
    href: '/courses/advanced',
  },
  {
    title: 'マスターコース',
    description: '管理・危機対応まで修める最上級課程',
    href: '/courses/master',
  },
  {
    title: '年間スケジュール',
    description: '開校時期と授業日程',
    href: '/schedule',
  },
  {
    title: 'コース別料金詳細',
    description: 'コースごとの料金内訳',
    href: '/pricing/details',
  },
  {
    title: 'カリキュラム',
    description: '各コースで学ぶ内容の全体像',
    href: '/curriculum',
  },
];